import * as _ from 'lodash';

export const GEOFENCE = {
  RADIAL: 'radial',
  POLYGON: 'polygon',
};

export const TASK_PRIORITY = {
  HIGH: {
    text: 'High',
    key: 'High',
    order: 3,
    backgroundColor: '#FDE6E0',
    textColor: '#000',
    borderColor: '#FF7C5B',
    dirtyBackground:
      'repeating-linear-gradient(135deg,#FDE6E0,#FDE6E0 6px,rgba(255,124,91,0.5) 1px,rgba(255,124,91,0.5) 8px) #FDE6E0',
  },
  MEDIUM: {
    text: 'Medium',
    key: 'Medium',
    order: 2,
    backgroundColor: '#FEF5D0',
    textColor: '#000',
    borderColor: '#FFCD00',
    dirtyBackground:
      'repeating-linear-gradient(135deg,#FEF5D0,#FEF5D0 6px,rgba(255,205,0,0.5) 1px,rgba(255,205,0,0.5) 8px) #FEF5D0',
  },
  LOW: {
    text: 'Low',
    key: 'Low',
    order: 1,
    backgroundColor: '#EFFAE4',
    textColor: '#000',
    borderColor: '#A0EC63',
    dirtyBackground:
      'repeating-linear-gradient(135deg,#EFFAE4,#EFFAE4 6px,rgba(160,236,99, 0.5) 1px,rgba(160,236,99, 0.5) 8px) #EFFAE4',
  },
  CRITICAL: {
    text: 'Critical',
    key: 'Critical',
    order: 4,
    backgroundColor: '#E6DEEB',
    textColor: '#000',
    borderColor: '#612141',
    dirtyBackground:
      'repeating-linear-gradient(135deg,#E6DEEB,#E6DEEB 6px,rgba(97,33,65, 0.3) 1px,rgba(97,33,65, 0.3) 8px) #E6DEEB',
  },
};

export const DASHED_BORDER_COLOR = 'rgb(66 79 98)';

export const BACKGROUND_COLOR_FOR_DIRTY = 'rgba(66,79,98,0.8)';

export const SCHEDULER_TASKS_STATES = {
  DIRTY: {
    key: 'dirty',
    displayName: 'Modified',
    border: `2px dashed ${DASHED_BORDER_COLOR}`,
    background: `repeating-linear-gradient(135deg,#FFFFFF,#FFFFFF 3px,${BACKGROUND_COLOR_FOR_DIRTY} 1px,${BACKGROUND_COLOR_FOR_DIRTY} 4px) #FFFFFF`,
  },
  DRAFT: { key: 'draft', displayName: 'Un Published', border: `2px dashed ${DASHED_BORDER_COLOR}` },
  PUBLISHED: { key: 'published', displayName: 'Published', border: `1px solid ${DASHED_BORDER_COLOR}` },
};

export const TASK_TABLE_ENUMS = {
  assignedToUserName: 'nameArray',
  area: 'areaNames',
  description: 'data.s_desc',
  taskTypeName: 'taskType.name',
  parentTaskName: 'parentTask.taskType.name',
  workordernumber: 'data.s_workordernumber',
  stopName: 'asset.stop.name',
  assetName: 'stopName',
  status: 'status',
  taskNumber: 'taskNumber',
  acceptRejectStatus: 'acceptRejectStatus',
  attachmentCount: 'attachmentCount',
  approvalStatus: 'approvalStatus',
  priorityAlias: 'priorityAlias',
  createdBy: 'createdBy',
  modifiedBy: 'modifiedBy',
  priority: 'priority',
  createdOn: {
    key: 'createdOn',
    value: 'DateUtils',
  },
  modifiedOn: {
    key: 'modifiedOn',
    value: 'DateUtils',
  },
  resolvedOn: {
    key: 'resolvedOn',
    value: 'DateUtils',
  },
  startTime: {
    key: 'startTime',
    value: 'DateUtils',
  },
  duration: {
    key: 'duration',
    value: 'TimeUtils',
  },
  delayMinutes: {
    key: 'delayMinutes',
    value: 'TimeUtils',
  },
};

export const FILTER_ENUMS = {
  TEMPFILTER: 'TempFilter',
  SELECTEDFILTER: 'SelectedFilter',
  FILTERKEYVALUE: 'filterModel',
  filterConditions: {
    NOTCONTAINS: 'notContains',
    STARTSWITH: 'startsWith',
    NOTEQUAL: 'notEqual',
    EQUALS: 'equals',
    ENDSWITH: 'endsWith',
    CONTAINS: 'contains',
    LESSTHAN: 'lessThan',
    LESSTHANOREQUAL: 'lessThanOrEqual',
    GREATERTHAN: 'greaterThan',
    GREATERTHANOREQUAL: 'greaterThanOrEqual',
  },
  filterType: {
    TEXT: 'text',
    SET: 'set',
    NUMBER: 'number',
  },
  TIMEUTILS: 'TimeUtils',
  DATEUTILS: 'DateUtils',
};

export const TASK_PRIORITY_KEYED = _.keyBy(Object.values(TASK_PRIORITY), 'key');

export const REASSIGNED_BY_LEVELS = {
  ANY_TEAM_MEMBER: { text: 'Any Team Member', key: 'anyteammember' },
  // FOREMAN: { text: 'Foreman', key: 'foreman' },
  ASSIGNEE: { text: 'Assignee', key: 'assignee' },
};

export const EVENT_SOURCE = {
  RECURRING: 'Recurring',
  MANUAL: 'Manual',
  SCADA: 'SCADA',
  SAPPM: 'SAP-PM',
  JOYNDR: 'Joyn-DR',
  ORACLEEAM: 'Oracle-EAM',
  AUTO: 'Auto',
  INFOREAM: 'Infor EAM',
  API: 'API',
  LAND: 'Land',
};

export const STATUS_LIST = {
  RESOLVED: {
    text: 'Resolved',
    key: 'resolved',
    color: '#E2F1EA',
    borderColor: '#70C5A4',
  },
  OPEN: { text: 'Open', key: 'open', color: '#DAE6F3', borderColor: '#3280C9', backgroundForLegend: '#3280C9 ' },
  DRAFT: { text: 'Draft', key: 'draft', color: '#F2F9FB', borderColor: '#424F62', backgroundForLegend: '#424F62 ' },
  NOT_READY: {
    text: 'Not Ready',
    key: 'notready',
    color: '#F0D2F9',
    borderColor: '#C920E8',
    backgroundForLegend: '#C920E8',
  },
  CHANGE_REQUEST: {
    text: 'Change Request',
    key: 'changerequest',
    color: '#E0D7FF',
    borderColor: '#6C21FF',
    backgroundForLegend: '#6C21FF',
  },

  READYTOACCEPT: {
    text: 'Ready To Accept',
    key: 'readytoaccept',
    color: '#DBEDFB',
    borderColor: '#40B8EA',
    backgroundForLegend: '#40B8EA',
  },

  MOREINFOREQUIRED: {
    text: 'More Info Required',
    key: 'moreinforequired',
    color: '#FEF5D0',
    borderColor: '#FFCD00',
    backgroundForLegend: '#FFCD00',
  },

  INPROGRESS: {
    text: 'In Progress',
    key: 'inprogress',
    color: '#FFEACD',
    borderColor: '#FBA51A',
    backgroundForLegend: '#FBA51A',
  },

  CANCELLED: {
    text: 'Cancelled - Closed',
    key: 'cancelled',
    color: '#F0D2F9',
    borderColor: '#C900E8',
    backgroundForLegend: '#C900E8',
  },
};

export const STATUS_LIST_VALUE_KEYED = _.keyBy(Object.values(STATUS_LIST), 'key');

export const ATTRIBUTE_TYPE = {
  STRING: { text: 'String', key: 'string' },
  INTEGER: { text: 'Integer', key: 'integer' },
  PICKLIST: { text: 'Picklist', key: 'picklist' },
  BOOLEAN: { text: 'Boolean', key: 'boolean' },
  DECIMAL: { text: 'Decimal', key: 'decimal' },
  DATE: { text: 'Date', key: 'date' },
  TIME: { text: 'Time', key: 'time' },
  DATE_TIME: { text: 'Date Time', key: 'datetime' },
  METADATA_DYNAMIC_LIST: { text: 'Metadata Dynamic List', key: 'metadatadynamiclist' },
  GUAGE: { text: 'Gauge', key: 'guage' },
};

export const ATTRIBUTE_TYPE_KEYED = _.keyBy(Object.values(ATTRIBUTE_TYPE), 'key');

export const NOTIFICATION_PROFILE = {
  ROUTINE: {
    text: 'Routine',
    value: 0,
  },
  MEDIUM: {
    text: 'Medium',
    value: 1,
  },
  VERBOSE: {
    text: 'Verbose',
    value: 2,
  },
  CUSTOM: {
    text: 'Custom',
    value: 3,
  },
};

export const PROFILES = ['ROUTINE', 'MEDIUM', 'VERBOSE', 'CUSTOM'];
export const NOTIFICATION_PROFILE_KEYBY_VALUE = _.keyBy(NOTIFICATION_PROFILE, 'value');

export const ACTIONS_ENABLED = {
  ASSIGN: {
    text: 'Assign/Unassign/Reassign',
    value: 0,
  },
  ACCEPT: { text: 'Accept/Reject', value: 1 },
  STATUS_CHANGE: {
    text: 'Status Change',
    value: 2,
  },
  LINKED_TASK_UPDATE: {
    text: 'Linked Task Created Update',
    value: 3,
  },
  SCHEDULE_UPDATE: {
    text: 'Schedule update ',
    value: 4,
  },
  COMMENTS_UPDATE: {
    text: 'Comments Update',
    value: 5,
  },
  APPROVAL_STATUS_CHANGE: {
    text: 'Approval Status Change',
    value: 6,
    onlyapproval: true,
  },
  GLOBAL_APPROVAL_STATUS_CHANGE: {
    text: 'Global Approval Status Change',
    value: 7,
    onlyapproval: true,
  },
  REQUESTER_CHANGE: {
    text: 'Requester Change',
    value: 8,
    onlyapproval: true,
  },
  APPROVER_CHANGE: {
    text: 'Approver Change',
    value: 9,
    onlyapproval: true,
  },
  GLOBAL_ATTRIBUTE_UPDATE: {
    text: 'Global attribute update',
    value: 10,
  },
  FORM_UPDATE: {
    text: 'Form update',
    value: 11,
  },
  TASK_ATTRIBUTE_UPDATE: {
    text: 'Task Attribute update',
    value: 12,
  },
  PRIORITY_CHANGE: {
    text: 'Priority Change',
    value: 13,
  },
  TASK_DELETED: {
    text: 'Task Deleted',
    value: 14,
  },
  CORE_ATTRIBUTE_CHANGE: {
    text: 'Core Task Attribute Change',
    value: 15,
  },
};
export const USER_TYPE = {
  ASSIGNEE: { text: 'Assignee', value: 0 },
  CREATOR: { text: 'Creator', value: 1 },
  TEAM_FOREMAN: {
    text: 'Team Leads',
    value: 2,
  },
  APPROVER: { text: 'Approver', value: 3, onlyapproval: true },
  REQUESTER: { text: 'Requester', value: 4, onlyapproval: true },
  WATCHERS: { text: 'Watchers', value: 5 },
};

export const SECTIONS_TO_DISPLAY = {
  SCHEDULING_DETAILS: { text: 'Scheduling Details', value: 0 },
  GLOBAL_ATTRIBUTES: {
    text: 'Global Attributes',

    value: 1,
  },
  FORM_ATTRIBUTES: { text: 'Form Attributes', value: 2 },
  DEPENDENT_TASKS: { text: 'Dependent Tasks', value: 3 },
  TASK_ATTRIBUTES: { text: 'Task Attributes', value: 4 },
};

export const USER_ROLE = {
  FOREMAN: 'foreman',
  LEASE_OPERATOR: 'leaseoperator',
  TECHNICIAN: 'technician',
  TEAM_MEMBERS: 'teammembers',
  TEAM_LEADS: 'teamleads',
};

export const LOGS_TYPE = {
  DEVICE_LOGS: { value: 'devicelogs', text: 'Device Logs', key: 'devicelogs' },
  TRACKER: { value: 'trackers', text: 'User Activity Logs', key: 'trackers' },
};

export const ENTITY_TYPES = {
  STOP: { text: 'Stop', key: 'stop', value: 'stop' },
  // ASSET: { label: 'ASSET', key: 'asset' },
};

export const TASK_ATTRIBUTE = {
  ECONOMICS: { text: 'Economics', key: 'economics_id', value: 'economics_id' },
};

export const OPERATORS = {
  EQUALS: { text: 'Equal to (=)', key: 'eq', value: '=' },
  // LTE: { text: '<=', key: 'lte', value: 'lte' },
  // GTE: { text: '>=', key: 'gte', value: 'gte' },
  NOTEQUALS: { text: 'Not equal to (!=)', key: 'ne', value: '!=' },
};

export const APPROVAL_FLOW_TYPES = {
  PARALLEL: { label: 'Parallel', key: 'parallel' },
  SERIES: { label: 'Series', key: 'series' },
};

export const GLOBAL_APPROVAL_STATUS = {
  PENDING_APPROVAL: {
    label: 'Pending Approval',
    key: 'pendingapproval',
    backgroundColor: '#dae6f3',
    borderColor: '#3280c9',
  },
  DENIED: { label: 'Denied', key: 'denied', backgroundColor: '#fde6e0', borderColor: '#ff7e5b' },
  APPROVED: { label: 'Approved', key: 'approved', backgroundColor: '#e2f5cc', borderColor: '#35d902' },
  ON_HOLD: { label: 'On Hold', key: 'onhold', backgroundColor: '#fef5d0', borderColor: '#ffcd00' },
  NEED_MORE_INFO: { label: 'Need More Info', key: 'needmoreinfo', backgroundColor: '#e0d7ff', borderColor: '#6c21ff' },
};
export const APPROVAL_OPTIONS = {
  APPROVE: {
    label: 'Approve',
    key: 'approve',
    content: 'Approved',
    status: GLOBAL_APPROVAL_STATUS.APPROVED.key,
    statusText: GLOBAL_APPROVAL_STATUS.APPROVED.label,
  },
  DENY: {
    label: 'Deny',
    key: 'deny',
    content: 'Denied',
    status: GLOBAL_APPROVAL_STATUS.DENIED.key,
    statusText: GLOBAL_APPROVAL_STATUS.DENIED.label,
  },
  ON_HOLD: {
    label: 'On Hold',
    key: 'onhold',
    content: 'On Hold',
    status: GLOBAL_APPROVAL_STATUS.ON_HOLD.key,
    statusText: GLOBAL_APPROVAL_STATUS.ON_HOLD.label,
  },
  NEED_MORE_INFO: {
    label: 'Need more Info',
    key: 'needmoreinfo',
    content: 'Need more Info',
    status: GLOBAL_APPROVAL_STATUS.NEED_MORE_INFO.key,
    statusText: GLOBAL_APPROVAL_STATUS.NEED_MORE_INFO.label,
  },
};

export const APPROVAL_OPTIONS_KEYED = _.keyBy(Object.values(APPROVAL_OPTIONS), 'key');

export const GLOBAL_APPROVAL_STATUS_KEYED = _.keyBy(Object.values(GLOBAL_APPROVAL_STATUS), 'key');

export const FILTER_OPERATION = {
  UPDATE: 'update',
  SAVE: 'save',
  DELETE: 'delete',
};

export const ATTRIBUTE_TYPE_IN_TASK = {
  GLOBAL_ATTRIBUTE: 'globalAttribute',
  TASKTYPE_ATTRIBUTE: 'taskTypeAttribute',
  FORM_ATTRIBUTE: 'formAttribute',
};

export const ENTER_KEY_CODE = 13;
export const KEY_PRESS_DOWN = 'keydown';

export const ASSET_TYPES = {
  STOP: { value: 'stop', key: 'stop', text: 'Stop' },
  WELL: { value: 'well', key: 'well', text: 'Well' },
  METER: { value: 'meter', key: 'meter', text: 'Meter' },
  TANK: { value: 'tank', key: 'tank', text: 'Tank' },
  EQUIPMENT: { value: 'equipment', key: 'equipment', text: 'Equipment' },
};

export const ASSET_TYPES_KEYS = Object.keys(_.keyBy(ASSET_TYPES, 'value'));
